import request from '@/utils/request'

// 搜索用户（根据邮箱或用户名）
export function searchUser(identifier) {
  return request({
    url: '/shares/search-user',
    method: 'post',
    data: { identifier }
  })
}

// 创建机器人分享
export function createRobotShare(data) {
  return request({
    url: '/shares',
    method: 'post',
    data
  })
}

// 获取机器人的所有分享
export function getRobotShares(robotId) {
  return request({
    url: `/robots/${robotId}/shares`,
    method: 'get'
  })
}

// 更新机器人分享
export function updateRobotShare(shareId, data) {
  return request({
    url: `/shares/${shareId}`,
    method: 'put',
    data
  })
}

// 删除机器人分享
export function deleteRobotShare(shareId) {
  return request({
    url: `/shares/${shareId}`,
    method: 'delete'
  })
}

// 切换分享状态
export function toggleRobotShare(shareId) {
  return request({
    url: `/shares/${shareId}/toggle`,
    method: 'put'
  })
}

// 获取分享给我的机器人
export function getSharedRobots() {
  return request({
    url: '/shares/shared-to-me',
    method: 'get'
  })
}
